import {Component, OnInit, Inject} from '@angular/core';
import { DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import { MatDialog} from '@angular/material/dialog';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import {ConfirmComponent} from '../../../shared/dialogs/confirm/confirm.component';
import {SubcategoryService} from '../../../services/subcategory.service';
import {Subcategory} from '../../../models/subcategory';
import {SnackBarIconService} from '../../../shared/snack-bar-icon/snack-bar-icon.service';
import {SubcategoryDocDialogComponent} from '../subcategory-doc-dialog/subcategory-doc-dialog.component';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-subcategory-dialog',
  templateUrl: './subcategory-dialog.component.html',
  styleUrls: [ './subcategory-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class SubcategoryDialogComponent implements OnInit {

  //public Editor = ClassicEditor;
  public local_title: string;
  public matcher = new FormErrorStateMatcher();
  public entityForm: FormGroup;
  public isEdit: boolean;
  public spinner: boolean = false;

  constructor (
     public matDialogRef: MatDialogRef<SubcategoryDialogComponent>,
    private fb: FormBuilder,
    private _subcategoryService: SubcategoryService,
    private snackBar: SnackBarIconService,
    private _adapter: DateAdapter<any>,
     private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: Subcategory
  ) { 
    // console.log(JSON.stringify(this.data))
  }


  ngOnInit () {

    this._adapter.setLocale('pt');

    // check is is insert or update
    if (this.data.id != "0") {
      this.isEdit = true;
      this.local_title = "Edição: " + this.data.name
    } else {
      this.isEdit = false
      this.local_title = "Nova Categoria"
    }

    this.entityForm = this.createForm()
    this.setFormValues(this.data, this.entityForm)
  }

  insert () {

    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: Subcategory = this.createEntity(this.entityForm.value);

      this._subcategoryService.insert(entity)
        .then((result) => {
          this.data.id = result.id
          this.isEdit = true;
          this.entityForm.controls.id.setValue(result.id);
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("insert category error: " + error)
          let msgError: string = this._subcategoryService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }

  }

  update () {

    if (this.entityForm.valid) {
      this.spinner = true;
      let entity: Subcategory = this.createEntity(this.entityForm.value);

      this._subcategoryService.update(entity)
        .then(() => {
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("category update error: " + JSON.stringify(error))
          let msgError: string = this._subcategoryService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false
        });
    }
  }

  createEntity (data: any): Subcategory {
    let entity = new Subcategory();
    entity.id = data.id;
    entity.name = data.name;
    entity.documents = data.documents ? data.documents : "";
    entity.documents_en = data.documents_en ? data.documents_en : "";
    //
    entity.docList = data.docList ? data.docList : [];

    if (!data.partner)
      entity.partner = false
    else
      entity.partner = true

    if (!data.hidden)
      entity.hidden = false
    else
      entity.hidden = true

    if (!data.sponsor)
      entity.sponsor = false
    else
      entity.sponsor = true

    if (!data.front_desk)
      entity.front_desk = false
    else
      entity.front_desk = true

    if (!data.annuity)
      entity.annuity = false
    else
      entity.annuity = true


    return entity;
  }

  setFormValues (data, form) {
    form.controls.id.setValue(data.id);
    form.controls.name.setValue(data.name);
    form.controls.partner.setValue(data.partner);
    form.controls.hidden.setValue(data.hidden);

    form.controls.sponsor.setValue(data.sponsor);
    form.controls.front_desk.setValue(data.front_desk);
    form.controls.annuity.setValue(data.annuity);

    form.controls.documents.setValue(data.documents);
    form.controls.documents_en.setValue(data.documents_en);
    form.controls.docList.setValue(data.docList);

  }

  createForm () {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      name: new FormControl('', [ Validators.required ]),
      partner: new FormControl(false),
      hidden: new FormControl(false),
      sponsor: new FormControl(false),
      front_desk: new FormControl(false),
      annuity: new FormControl(false),
      documents: new FormControl(''),
      documents_en: new FormControl(''),
      docList: new FormControl(''),
    });
    return form
  }

  openDocDialog (element: any) {

    let data: any = {}
    if(element){
      data = element
    }

    let dialogRef = this.dialog.open(SubcategoryDocDialogComponent, {
      width: '600px',
      height: '350px',
      panelClass: 'custom-dialog-container',
      data: data,
    });

    dialogRef.afterClosed()
    .subscribe(response => {
        if (!response) {
            return;
        }

        const actionType: string = response[0];
        const form: FormGroup = response[1];
        
        let formData: any = form.getRawValue();
        if (actionType == 'insert') {
          const dt = new Date();
          const token = dt.getTime()
          const data = {
            id: token,
            doc: formData.doc
          }
          
          if(!this.data.docList) this.data.docList = [];

          this.data.docList.push(data)
          this.entityForm.controls.docList.setValue(this.data.docList);
        } else if (actionType == 'update'){
          this.data.docList.forEach((item)=>{
            if(item.id == formData.id){
              item.doc = formData.doc;
            }
          })
          this.entityForm.controls.docList.setValue(this.data.docList);
        }
      })
  }

  removeDocument(id) {
    let dialogRef = this.dialog.open(ConfirmComponent, {
      width: '350px',
      height: '270px',
      panelClass: 'custom-dialog-container',
      data: { title: "Confirme", message: "<br><br>Excluir este documento?" }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "ok") {
          this.data.docList = this.data.docList.filter((e)=>{
            return e.id !== id;
          })
          this.entityForm.controls.docList.setValue(this.data.docList);
      }
    })
  }

}